import React from 'react'
import './FooterInfo.css'

export default function FooterInfo({title, value = '', icon}) {
  const iconComp = icon ? icon : <></>;
  const style = `footerInfo ${value}`
  return (
    <div className={style}>
      <div className='footerInfoTitle'>{title}</div>
      <div className='footerInfoIcon'>{iconComp}</div>
      <div className='footerInfoValue'>{value}</div>
    </div>
  )
}
